import Service from "../../AuthService";
const Department = {
    getDepartment(page) {
        return Service.get("/department?page="+page);
    },
    showDepartment(id) {
        return Service.get("/department/" + id);
    },
    updateDepartment(id, data) {
        return Service.put("/department/" + id, data);
    },
    createDepartment(data) {
        return Service.post("/department", data);
    },
    deleteDepartment(id) {
        return Service.delete("/department/" + id);
    },
    getAllDepartment(){
        return Service.get("/department_get_all");
    }
};
export default Department;
